import {Injectable} from '@angular/core';
import {LoggerService} from "../logger.service";

declare var localStorage: any;

/**
 * Service implementation for window.localStorage
 */
@Injectable()
export class LocalStorage {

    private _localStorage: any;

    constructor(private logger: LoggerService) {
        if (typeof(Storage) !== 'undefined') {
            this._localStorage = localStorage;
            logger.log('LocalStorage: localStorage is supported');
        } else {
            this._localStorage = {
                setItem: function () {
                    ;
                },
                removeItem: function () {
                    ;
                }
            };
            logger.warn('LocalStorage: localStorage is NOT supported');
        }
    }

    public set(key: string, value: string): void {
        this._localStorage.setItem(key, value);
    }

    public get(key: string): string {
        return this._localStorage[key];
    }

    public setObject(key: string, value: any): void {
        this._localStorage.setItem(key, JSON.stringify(value));
    }

    public getObject(key: string): any {
        return JSON.parse(this._localStorage[key] || '{}');
    }

    public remove(key: string): any {
        this._localStorage.removeItem(key);
    }
}
